import { hexToRGBA } from "@utils";
import { AutocompleteRenderGetTagProps, SxProps, Theme } from "@mui/material";
import {
  SHCheckbox,
  SHChip,
  SHStack,
  SHTypography,
} from "@components/design-systems";
import React from "react";
import { ModelScreenerFilterDropdownLov } from "@models/model-screener/entities/modelScreenerFilter";

export const getMSFilterSwitchYesNoToggleButtonSx = ({
  isSmallSize,
  theme,
}: {
  theme: Theme;
  isSmallSize: boolean;
}): SxProps<Theme> => {
  const { palette, shadows } = theme;

  return {
    ".MuiToggleButtonGroup-root": {
      border: "none",
      button: {
        height: isSmallSize ? "28px" : "32px",
        "&:nth-of-type(1)": {
          marginRight: "5px",
        },
        "&:nth-of-type(3)": {
          marginLeft: "5px",
        },
      },
      justifyContent: "space-between",
    },
    ".MuiToggleButton-root": {
      backgroundColor: hexToRGBA(palette.common.black, 0.08),
      boxShadow: shadows[1],
      maxWidth: "33%",
    },
    ".MuiToggleButton-root.Mui-selected": {
      backgroundColor: palette.primary.main,
      boxShadow: `inset 3px 3px 4px ${hexToRGBA(palette.common.black, 0.5)}`,
      svg: {
        marginRight: "-7px",
      },
      maxWidth: "33%",
    },
  };
};

export const renderTags = ({
  value,
  getTagProps,
  isSmallSize,
}: {
  value: ModelScreenerFilterDropdownLov[];
  getTagProps: AutocompleteRenderGetTagProps;
  isSmallSize: boolean;
}) => {
  return value.map((option, index) => (
    <SHChip
      {...getTagProps({ index })}
      key={index}
      label={option.name}
      sx={{
        height: isSmallSize ? 25 : 32,
        ".MuiChip-label": {
          paddingY: "0 !important",
          paddingLeft: "8px !important",
          marginTop: "4px",
        },
        svg: {
          margin: "0 3px 0 -5px !important",
          width: isSmallSize ? 15 : 18,
        },
      }}
    />
  ));
};

export const renderOptions = ({
  props,
  option,
  selected,
  index,
}: {
  props: React.HTMLAttributes<HTMLLIElement>;
  option: ModelScreenerFilterDropdownLov;
  selected: boolean;
  index: number;
}) => {
  return (
    <li {...props} key={index} style={{ padding: "1px 10px" }}>
      <SHStack alignItems={"center"} direction="row" spacing={1}>
        <SHCheckbox checked={selected} />
        <SHTypography variant="body3" fontWeight={500}>
          {option.name}
        </SHTypography>
      </SHStack>
    </li>
  );
};

export const getMSFilterSwitchYesNoToggleButtonWidth = (
  windowWidth: number,
) => {
  if (windowWidth < 1070) return "49px";
  if (windowWidth < 1110) return "52px";
  if (windowWidth < 1150) return "55px";
  return "100%";
};
